export const STATUS_EARLY = 'is_early';
export const STATUS_ABSENCE = 'is_absence';
export const STATUS_LATE = 'is_late';
export const STATUS_ONTIME = 'is_ontime';
export const STATUS_PRESENT = 'is_present';

/* Status Select Option List */
export const SELECT_OPTION_STATUS_LIST = [
  {
    id: '',
    label: '-- Semua Status --'
  },
  {
    id: STATUS_PRESENT,
    label: 'Hadir'
  },
  {
    id: STATUS_ABSENCE,
    label: 'Tidak Hadir'
  },
  {
    id: STATUS_ONTIME,
    label: 'Tepat Waktu'
  },
  {
    id: STATUS_LATE,
    label: 'Terlambat'
  },
  {
    id: STATUS_EARLY,
    label: 'Pulang Lebih Awal'
  }
];

export const SELECT_OPTION_YEAR_LIST = [
  { id: '2022', label: 'Tahun 2022' }
]

export const SELECT_OPTION_MONTH_LIST = [
  { id: '01', label: 'Januari' },
  { id: '02', label: 'Februari' },
  { id: '03', label: 'Maret' },
  { id: '04', label: 'April' },
  { id: '05', label: 'Mei' },
  { id: '06', label: 'Juni' },
  { id: '07', label: 'Juli' },
  { id: '08', label: 'Agustus' },
  { id: '09', label: 'September' },
  { id: '10', label: 'Oktober' },
  { id: '11', label: 'November' },
  { id: '12', label: 'Desember' }
]